let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("PnSMA")).then(() => parcelRequire('6lUKc'));